export default __webpack_public_path__ + "static/media/helper-survey.0075535b.png";